import styles from "./imagesChat.module.scss";
import React, { Fragment, useState } from "react";

import ChatLike from "../chatLike";
import { Tooltip } from "antd";
import ChatHoverOption from "../chatHoverOption";
//import { StatusTag } from "../../../../shared/widgets/statusTag";
import moment from "moment";
import ChatUserInfo from "../chatUserInfo";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import FilePreview from "../filePreview";
import { chats, initialStateModel } from "../../../../models/model";
import { useSelector } from "react-redux";
import store from "../../../../context/store/store";
import { Types } from "../../../../context/action/action";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
import { ChatService } from "../../../../base/chatService";
import ImagePreview from "../MultiimageChat/imagePreview";
import { urlify } from "../../../../base/utils";

type imagemessageProps ={
  data:any;
 
}
type fileMessageState = {
  isOpen:boolean;
  id:any;
}
export default function ChatImageMessage({data}:imagemessageProps) {

  //const chatWindow: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  //let { archiveMessageArray}:any = chatWindow;
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  let { messageList }: any = chatSocketMessage;
  let { id,  direction, timestamp, fromcaller_details} = data;
  let messageBody = data.message.body;
 // let messageBody = data?.message?.body ?_.isObject(data.message.body) && !data?.message?.isDeleted ? data.message.body: !data?.message?.isDeleted ? JSON.parse(data.message.body):"":"";
  let isReply = data.message?.isReply?true:false;
  const [longText, setlongtext] = useState(0);
  let mstext = messageBody?.text;
    if(mstext && mstext !== ""){
      if (mstext?.length > 760 && longText === 0) {
        mstext = mstext.substring(0, 760) + "...";
      }
    }
  var imgArr:any = [];
  imgArr.push(data);
  const [fileState, setfileState] = useState<fileMessageState>({isOpen:false,id:''});
 
  let htimestamp = moment(timestamp).format('hh:mm A');
  const FilePreviewer = ()=>{

    setfileState({...fileState,isOpen:!fileState.isOpen});
  };

  const handleCheckBoxClick =()=>{
    if(chatReducer?.isDelete || chatReducer?.isForward){
      ChatService.selectedMessageDispatch(data);
    }
  };

  const handlehighlightHover =()=>{
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }
    
  };
  
  const handleOnChange =(e:any)=>{
    let deletedArray:any = chatReducer.selectMessageData;
    let index = [];
    if (e.target.checked) {
      deletedArray.push(data);
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData:deletedArray
        }
      });
    } else {
      index = deletedArray.indexOf(data);
      deletedArray.splice(index, 1);
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData:deletedArray
        }
      });
    }
  };
  const readMoreChange = ()=>{
    setlongtext(1);
  }
  return (
    <>{
      direction === 'IN' ? <div className={`${styles.chatMsg} ${styles.leftMessage}`} id={id}>
        <div className={`${styles.chatUserDetails}`}>
          {!isReply && <ChatUserInfo userDetails = {fromcaller_details} className='userinfoIcon leftSide'/>}
         
        </div>
        <div className={styles.chatLeftMessages}>
          <div className={styles.chatLeft}>
            <Tooltip  mouseEnterDelay={0.5} title={htimestamp} className='cusTooltip'
              overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>
           
            <div className={styles.chatContent}>
              <div className={isReply ? `${styles.imageChat} replyImageType` : styles.imageChat }>
                <div className={styles.imageList}>
                {imgArr.map((msgList: any, index: any) => {
                          return (
                            <Fragment key={index}>
                             <ImagePreview index={index} data={msgList} multiData={imgArr}></ImagePreview>
                          
                            </Fragment>
                          );
                        
                      })}
                </div>
                {messageBody?.text !== "" && <>
                <div className="textContent">
                      <span className={`textmsg ${styles.messageContent}`} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>
                      <span className="width75"></span>
                    </div>
               </>}
              {messageBody?.text &&  <ChatLeftInfo userDetails = {fromcaller_details}
                    timeStamp = {timestamp} message={data}></ChatLeftInfo>}
              </div>
              {/* <StatusTag className='statusTag atMentionTag' name='@ Miguel Logan'/> */}
              {!isReply && <ChatLike className='likeLeft' placement="top"
                tooltipTitle={data?.likeduserdetails}
                message={data}/>}
            </div>
          </div>
        </div>
        { !isReply && <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
          <ChatHoverOption className='hoverList hoverListleft' data={data} highlightHover={handlehighlightHover}/></div>}
      </div> :<div className={`${styles.chatMsg} ${styles.rightMessage}
        ${(chatReducer?.isDelete || chatReducer?.isForward)? "checkboxing" : ""} `} onClick={handleCheckBoxClick} id={id}>

        <div className={`${styles.chatUserDetails}`}>
          
          {!isReply &&  <ChatUserInfo userDetails = {fromcaller_details} className='userinfoIcon rightSide'/>}
        </div>
        <div className={styles.chatRightMessages} >
          <div className={styles.chatRight} >
            <div className={styles.chatContent}>
              <div className={isReply ? `${styles.imageChat} replyImageType` : styles.imageChat }>
                <div className={styles.imageList}>
                  {imgArr.map((msgList: any, index: any) => {
                          return (
                            <Fragment key={index}>
                             <ImagePreview index={index} data={msgList} multiData={imgArr}></ImagePreview>
                          
                            </Fragment>
                          );
                        
                      })}
                </div>
                {messageBody?.text !== "" && <>
                <div className="textContent">
                      <span className={`textmsg ${styles.messageContent}`} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>
                      <span className="width75"></span>
                    </div>
               </>}
                    {messageBody?.text &&  <ChatRightInfo userDetails={fromcaller_details}
            timeStamp={timestamp} message={data}></ChatRightInfo>}
                    
              </div>
              {/* <StatusTag className='statusTag atMentionTag' name='@ Miguel Logan'/> */}
             { !isReply && <ChatLike className='likeRight' placement="topRight"
                tooltipTitle={data?.likeduserdetails} message={data}/>}
            </div>
            <Tooltip mouseEnterDelay={0.5}  placement="topRight" title={htimestamp}
              className='cusTooltip' overlayClassName='customTooltip'>
              <div className={styles.chatTime}>{htimestamp}</div></Tooltip>
          </div>
        </div>
        {!isReply &&  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
          <ChatHoverOption className='hoverList hoverListright' data={data} multiFile={imgArr} highlightHover={handlehighlightHover}/></div>}
        
        {!isReply && (chatReducer?.isDelete || chatReducer?.multiOption) &&<URCheckBoxCall
          checked={chatReducer?.selectMessageData?.indexOf(data) > -1 ? true : false}
          className="chatSelectRight" onChange={handleOnChange}/>}
      </div>
    }
    {fileState.isOpen && <FilePreview isOpen={fileState.isOpen} data={data} previewopen={FilePreviewer}  groupdata={messageList}
      />}
    </>
   
  );
};

